import ApiService from "../../services/api.service";
import { Notify } from 'quasar';

export const antenneAlertes = {
    state: {
        alertes: [],
        alerte: null,
        object: null
    },
    mutations: {
        setAlertes(state, alertes){
            state.alertes = alertes
        },
        setAlerte(state, alerte){
            state.alerte = alerte
        }
    },
    actions: {
        /* Alertes action GET */
        fetchAlertes(context, url ) {
          return ApiService.getRequest(url, true).then(
              response => {
                  context.commit('setAlertes', response.data);
              },
          )
          .catch(error =>{
              console.error(error);
              Notify.create({
                  message: "Une erreur s'est produite",
                  color: 'red'
              })
          })
        },
        //Récupération des alertes en fonction du type avec pagination
        async fetchAlertesByTypes(context, data){
          return ApiService.getRequest(`/global_alertes?type=${data.type}&pagination=true&page=${parseInt(data.page)}`).then(
            response => {
              context.commit('setAlertes', response.data);
            }
          ).catch(error => {
            console.error(error);
            Notify.create({
              message: "Une erreur s'est produite lors de la récupération des données",
              color: 'red'
            })
          })
        },
       //Récupétation alertes en fonction du type sans pagination
        fetchAlertesType(context, data){
          return ApiService.getRequest(`/global_alertes_type_antenne/${data.type}/${data.antenne}`).then(
            response => {
              context.commit('setAlertes', response.data);
            }
          ).catch(error => {
            console.error(error);
            Notify.create({
              message: "Une erreur s'est produite lors de la récupération des données",
              color: 'red'
            })
          })
        },

        //Recupère le nombre d'alertes à traité en fonction de la catégorie
        async fetchAlertesAtraiter(context){
          try{
            const response = await ApiService.getRequest('get_alertes_categories');
            context.commit('setAlertes', response.data.alertes);
          }catch(e){
            console.error(e);
            Notify.create({
              message: "Une erreur s'est produite",
              color: 'red'
            })
          }
        },

        /*Ajouts des alertes*/
        async addAlerte({state}, data){
            try {
                const response = await ApiService.postRequest('global_alertes', data);
                if(response.status === 201){
                    this.commit('callbackEditAlertes', response.data);
                    Notify.create({
                        message: "Une alerte à été ajoutée.",
                        color: 'green'
                    })
                    return Promise.resolve();
                }
            }
            catch (error){
              console.error(error);
                Notify.create({
                    message: "Une erreur est survenue lors de la création de l'alerte",
                    color: 'red'
                })
                return Promise.reject(error)
            }
        },
      //Suppression des Alertes Traitées
      async deleteAlerte(context, uri){
          try{
            const response = await ApiService.patchRequest(uri);
            if(response.status === 201){
              Notify.create({
                message: "Alerte supprimée avec succès",
                color: 'green'
              })
            }
          }catch(error){
            console.error(error);
            Notify.create({
              messsage: "Une erreur s'est produite lors de la suppression d'une donnée",
              color: 'red'
            })
          }
      }
    },
    getters: {
        getAlertes(state){
            return state.alertes;
        },
        getAlerte(state) {
            return state.alerte
        }
    }
}
